export const BASE_URL = 'http://npkirpribor.ru';
// export const BASE_URL = 'http://127.0.0.1:8000';
// export const BASE_URL = 'http://teplouchet-komplekt.ru';

export const SHOP_NAME = 'Научно-производственное предприятие "Омега Инжениринг"';
export const SLOGAN = 'Расходомеры, проверенные временем';

export const COMPANY_SELLER = {
  inn: "7705608400",
  kpp: "504401001",
  ogrn: "1047796517757",
  name: 'Общество с ограниченной ответственностью Научно-производственное предприятие "Омега Инжениринг"',
  short_name: 'ООО НПП "Омега Инжениринг"',
  adress: "141570, Московская область, г.о.Солнечногорск, рп. Менделеево, территория Промышленная зона Менделеево, стр.1А",
  bik: "044525555",
  bank_name: 'ПАО "Промсвязьбанк", г. Москва',
  korr_schet: "30101810400000000555",
  rass_schet: "40702810470210729801",
  email: "omega@omega-mera.ru",
  director_name: "Проценко Степан Викторович",
  director_post: "Генеральный директор",
  director_footing: "Устава",
  working_hours: "Пн-Пт с 9:00 до 18:00",
  okved: "33.20",
  okato: "45286560000",
  okopf: "65",
  okpo: "73819860",
  okfs: "16"
};

export const PHONE_NUMBERS = [
  {
    name: null,
    number: '+7 (495) 744-84-23',
    link: 'tel:+74957448423'
  },
]

export const EMAILS = [
  {
    name: null,
    email: 'omega@omega-mera.ru'
  },
]

export const Portal = {
  ApiResult: 'ApiResult',
  Slideshow: 'Slideshow',
  Overlay: 'Overlay',
  Empty: ''
}

export const ROUTES_CONST = [
  {
    path: "*", breadcrumb: "Страница не найдена",
    metaTitle: "Страница не найдена",
  },
  {
    path: "/", breadcrumb: "Главная",
    metaTitle: `Главная страница`,
  },
  {
    path: "/agreement", breadcrumb: "Пользовательское соглашение",
    metaTitle: "Пользовательское соглашение",
  },
  {
    path: "/personal-data", breadcrumb: "Политика обработки персональных данных",
    metaTitle: "Политика обработки персональных данных",
  },
  {
    path: "/cookie", breadcrumb: "Политика использования файлов Cookie",
    metaTitle: "Политика использования файлов Cookie",
  },
  {
    path: "/about", breadcrumb: "О компании",
    metaTitle: `О компании`,
  },
  {
    path: "/contacts", breadcrumb: "Контакты",
    metaTitle: "Контакты",
  },
  {
    path: "/catalog", breadcrumb: "Каталог",
    metaTitle: `Каталог`,
  },
  {
    path: "/products", breadcrumb: "Каталог",
    metaTitle: "Каталог",
  },
]

export const WIDTH_4 = 1200;
export const WIDTH_3 = 768;
export const WIDTH_2 = 540;
export const WIDTH_1 = 320;

export const BUTTON_MORE_TEXT = '';

export const SERVER_ERROR = `Во время запроса произошла ошибка. Возможно,
проблема с соединением или сервер недоступен. Подождите немного и попробуйте ещё раз.`;

export const TITLE_ERROR = 'Ошибка';
export const TITLE_NOTIFICATION = 'Уведомление';

export const START_CARDS_MORE_1200_PX = 16;
export const START_CARDS_MORE_768_PX = 12;
export const START_CARDS_MORE_540_PX = 8;
export const START_CARDS_MORE_320_PX = 4;

export const ADD_CARDS_MORE_1200_PX = 4;
export const ADD_CARDS_MORE_768_PX = 3;
export const ADD_CARDS_MORE_540_PX = 2;
export const ADD_CARDS_MORE_320_PX = 1;

export const WIDTH_1200_PX_4_CARDS = 1200;
export const WIDTH_768_PX_3_CARDS = 768;
export const WIDTH_540_PX_2_CARDS = 540;
export const WIDTH_320_PX_1_CARDS = 320;

export const BLUE_INTERFACE = [
  { name: 'color5', color: '#2d9cee' },
  { name: 'color5-1', color: '#31a9ff' },
  { name: 'color5-2', color: '#2583c7' },
  { name: 'color6', color: '#00186a' }
]

export const FILE_TYPES = [
  { type: 'program', name: 'Программа'},
  { type: 'document', name: 'Документ'},
  { type: 'certificate', name: 'Сертификат'},
]
